/**
 * Vehicle product page responsive breakpoints (px).
 * Must match variables in vehicle-product-page.sass — update both when changing.
 *
 * mobile:  0 – 767
 * tablet:  768 – 1199 (includes iPad / iPad Pro)
 * desktop: 1200+
 */
export const VP_MOBILE_MAX = 767;
export const VP_TABLET_MIN = 768;
export const VP_TABLET_MAX = 1199;
export const VP_DESKTOP_MIN = 1200;
